import { faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindActionCreators } from "@reduxjs/toolkit";
import { ModalEnum } from "myParkdUtils/enums";
import { connect } from "react-redux";
import { MinimalUser } from "types";
import * as modalWindowActions from 'root/modal/modalWindowActions';


export const UserActionButtons = (props: Props) => {
    const { user } = props;

    return (
        <div className="buttons-group-left">
            <button
                className='btn-icon-blue'
                onClick={() => props.updateModal(ModalEnum.EDIT_USER, { user })}
                data-testid='btn-edit-user'
            >
                <FontAwesomeIcon icon={faPencil} size='1x' />
            </button>
            <button
                className='btn-icon-red'
                onClick={() => props.updateModal(ModalEnum.DELETE_USER, { user })}
                data-testid='btn-delete-user'
            >
                <FontAwesomeIcon icon={faTrash} size='1x' />
            </button>
        </div>
    )
}

// @ts-ignore
type OwnProps = { user: MinimalUser }
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(UserActionButtons);